var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kura_tm_all_wrap"},[_c('Settings'),_c('ModalBox'),_c('Header'),_c('Home'),_c('Portfolio'),_c('Skills'),_c('Timeline'),_c('Pricing'),_c('News'),_c('Contact'),_c('Footer'),_c('Audio'),_c('Mouse')],1)}
var staticRenderFns = []

export { render, staticRenderFns }